<style>
    input:disabled,
    input[disabled]{
      border: 1px solid #999999;
      background-color: white !important;
      color: #000000;
    }
</style>
<template>
  <div>
      
   <base-header class="header pb-8 pt-5 pt-lg-8 d-flex align-items-center"
          style="min-height: 60px; background-image: url(img/theme/profile-cover.jpg); background-size: cover; background-position: center top;">
            <!-- Mask -->
            <span class="mask bg-gradient-success opacity-8"></span>
            <!-- Header container -->
            <div class="container-fluid d-flex align-items-center">
                <div class="row">
                    <div class="col-lg-7 col-md-10">
                        <!-- <h1 class="display-2 text-white">Washing Machine</h1> -->
                        <!-- <p class="text-white mt-0 mb-5"></p> -->
                        <!-- <a href="#!" class="btn btn-info">Edit profile</a> -->
                    </div>
                </div>
            </div>
   </base-header>

    <div class="container-fluid mt--7">
      <div class="row">
       
        <!-- <div v-for="item in profile" class="col-xl-4 order-xl-2 mb-5 mb-xl-0 pt-3">
          <div class="card card-profile shadow" style="background-color: #LightGray; border: solid;"> 
            <div class="row justify-content-center h1 font-weight-1000 mt-3 mb-3"  >
                    {{item.name}}
            </div>
           
            <div class="card-body pt-0 pt-md-4">
           
              <div class="text-center">
                <h3>
                  {{item.customer_name}}<span class="font-weight-light">, 083-xxxxxxxx</span>
                </h3>
                
                <div class="h3 mt-4">
                  <i class="ni business_briefcase-24 mr-2"></i>
                   วิธีการรับเงิน : {{item.withdraw_type}}
                </div>
               
                <router-link to="/changepassword2">
                        <button type="button" class="btn btn-outline-default mt-4">แก้ไขรหัสผ่าน</button>
                </router-link>
              </div>
            </div>
          </div>
        </div> -->
        
        <div class="col-xl-12 order-xl-1">
          <card shadow type="secondary">
            <template v-slot:header>
              <div class="bg-white border-0">
                <div class="row align-items-center">
                  <div class="col-8">
                    <h3 class="mb-0">ข้อมูลส่วนตัว</h3>
                  </div>
                  <!-- <div class="col-4 text-right">
                    <a href="#!" class="btn btn-sm btn-primary">Settings</a>
                  </div> -->
                </div>
              </div>
            </template>

            <form>
              <h6 class="heading-small text-muted mb-4">User information</h6>
              <div class="pl-lg-4">
                <div class="row">
                  <div class="col-lg-6">
                    <base-input
                      alternative=""
                      label="Username"
                      placeholder="Username"
                      input-classes="form-control-alternative"
                      v-model="profile.customer_name"
                      disabled
                    />
                  </div>
                  <div class="col-lg-6">
                    <base-input
                      alternative=""
                      label="Phone"
                      placeholder="Phone"
                      input-classes="form-control-alternative"
                      v-model="profile.customer_phone"
                      disabled
                    />
                  </div>
                 
                </div>
                <div class="row">
                  <div class="col-lg-12">
                    <base-input
                      alternative=""
                      label="Email address"
                      placeholder="jesse@example.com"
                      input-classes="form-control-alternative"
                      v-model="profile.name"
                      disabled
                    />
                  </div>
                  <!-- <div class="col-lg-6">
                    <base-input
                      alternative=""
                      label="Last name"
                      placeholder="Last name"
                      input-classes="form-control-alternative"
                      v-model="model.lastName"
                    />
                  </div> -->
                </div>
              </div>
              <hr class="my-4" />
              <h6 class="heading-small text-muted mb-4">financial information</h6>
              <div class="pl-lg-4">
                <div class="row">
                  <div class="col-lg-12">
                    <base-input
                      alternative=""
                      label="bank_account_name"
                      placeholder="bank_account_name"
                      input-classes="form-control-alternative"
                      v-model="profile.bank_account_name"
                      disabled
                    />
                  </div>
                </div>
                <div class="row">
                  <div class="col-lg-6">
                    <base-input
                      alternative=""
                      label="bank_account"
                      placeholder="bank_account"
                      input-classes="form-control-alternative"
                      v-model="profile.bank_account"
                      disabled
                    />
                  </div>
               
                  <div class="col-lg-6">
                    <base-input
                      alternative=""
                      label="bank_name"
                      placeholder="bank_name"
                      input-classes="form-control-alternative"
                      v-model="profile.bank_name"
                      disabled
                    />
                  </div>
                </div>
                 <div class="row">
                  <div class="col-md-12">
                    <base-input
                      alternative=""
                      label="withdraw_type"
                      placeholder="withdraw_type"
                      input-classes="form-control-alternative"
                      v-model="profile.withdraw_type"
                      disabled
                    />
                  </div>
                </div>
              </div>
              <hr class="my-3" />
               <h6 class="heading-small text-muted mb-4">reset password</h6>

               <div class="row">
            
                  <div class="col">
                   
                        <button type="button" class="btn btn-outline-default mt-1" v-on:click="checkValidMail()">แก้ไขรหัสผ่าน</button>
      
                  </div>
                  <!-- <div class="col-12 text-center">
                   
                        <button type="button" class="btn btn-outline-default mt-4" v-on:click="checkValidMail()">แก้ไขรหัสผ่าน</button>
      
                  </div> -->
                </div>
           
              <!-- <h6 class="heading-small text-muted mb-4">About me</h6>
              <div class="pl-lg-4">
                <div class="form-group">
                  <base-input alternative="" label="About Me">
                    <textarea
                      rows="4"
                      class="form-control form-control-alternative"
                      placeholder="A few words about you ..."
                    >
                        A beautiful Dashboard for Bootstrap 4. It is Free and Open Source.</textarea
                    >
                  </base-input>
                </div>
              </div> -->
            </form>
          </card>
        </div>
      </div>
    </div>
  </div>
</template>
 
<script>
  import JwService from '../service/justwash';

  export default {
    name: 'user-profile',
    data() {
      return {
        model: {
          username: '',
          email: '',
          firstName: '',
          lastName: '',
          address: '',
          city: '',
          country: '',
          zipCode: '',
          about: ''
        },
        profile: {},
        status_changepass: false,
      }
    },
    methods: {
       test:function(id) {
        console.log(id);

      },
      updateProfile:function() {
        alert('บันทึกข้อมูลส่วนตัวเรียบร้อยแล้ว');

      },
      updateContact:function() {
        alert('บันทึกข้อมูลติดต่อเรียบร้อยแล้ว');

      },
      updateBankAccount:function() {
        alert('บันทึกข้อมูลบัญชีรับเงินเรียบร้อยแล้ว');

      },
      updatePassword:function() {
        alert('บันทึกข้อมูลรหัสผ่านเรียบร้อยแล้ว');

      }, 
      checkValidMail:function() {
        if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(this.profile.name)) {
           this.$router.push('/changepassword2')
        } else {
          // this.$router.push('/changepassword2')
          alert('ไม่พบอีเมล')
        }
      }
    },
    mounted() {
      
      // this.initBigChart(0);
      // localStorage.getItem('accessToken');
      // console.log('Token '+localStorage.getItem('accessToken'));
      // var token = localStorage.getItem('accessToken');
      // console.log('Token '+token);
      axios({
        method: 'post',
        url: JwService.getAPI()+'/api/method/justwash.OwnerApi.GetProfile',
        data: {},
        headers: {
          'Authorization' : 'Token '+localStorage.getItem('accessToken')
        }
      }).then((response) => {
        
         this.profile = response.data.message[0];
        //  console.log(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(this.profile.name));
             if ( this.profile.withdraw_type == 'Day') {
                  this.profile.withdraw_type  = 'รายวัน';
             } 
             if (this.profile.withdraw_type == 'Week') {
                 this.profile.withdraw_type  = 'รายสัปดาห์';
             }  
             if (this.profile.withdraw_type == 'Month') {
                 this.profile.withdraw_type  = 'รายเดือน';
             }  

        if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(this.profile.name) == true) {
            this.profile.name =  this.profile.name;
        } else {
            this.profile.name =  null
        }
        
        if (this.profile.bank_account !== null) {
          let real = this.profile.bank_account.length - 4;
          let x = '';
          for (let index = 0; index < real; index++) {
            x = x + 'x'
          }
          // console.log(this.profile);
          this.profile.bank_account = x+this.profile.bank_account.substring(real);
        }
        
        // for (let index = 0; index <  this.profile.length; index++) {
        //      if ( this.profile[index].withdraw_type == 'Day') {
        //           this.profile[index].withdraw_type  = 'รายวัน';
        //      } 
        //      if (this.profile[index].withdraw_type == 'week') {
        //          this.profile[index].withdraw_type  = 'รายสัปดาห์';
        //      }  
        //      if (this.profile[index].withdraw_type == 'month') {
        //          this.profile[index].withdraw_type  = 'รายเดือน';
        //      }  
        //  console.log(this.profile);
        // }
       
      
      }).catch(error => {
        console.log(error)
        // this.$router.push('/login')
      });
    }
  };
</script>
<style></style>
